module.exports = __webpack_public_path__ + "img/banif.fe056f82.svg";